module.exports = __webpack_public_path__ + "img/17.a7c7d694.jpg";